import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { finalize } from 'rxjs/operators';
import { ApiService } from './api.service';
var SessionService = (function () {
    function SessionService(idle, keepalive, apiService) {
        this.idle = idle;
        this.keepalive = keepalive;
        this.apiService = apiService;
    }
    SessionService.prototype.start = function () {
        var _this = this;
        // timeout -- 4 + 1 mins
        this.idle.setIdle(4 * 60);
        this.idle.setTimeout(60);
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        this.idle.onTimeout.subscribe(function () {
            alert('Your session has expired due to inactive response, please log in again.');
            _this.logout();
        });
        this.keepalive.interval(30);
        this.idle.watch();
    };
    SessionService.prototype.stop = function () {
        this.idle.ngOnDestroy();
        this.idle.onTimeout.observers.length = 0;
        this.idle.onIdleStart.observers.length = 0;
        this.idle.onIdleEnd.observers.length = 0;
    };
    SessionService.prototype.logout = function () {
        this.apiService.logout().pipe(finalize(function () { return window.location.href = '/login'; })).subscribe();
        this.sniff('AUTO_LOGOUT', '');
    };
    SessionService.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'HOME',
            target: target
        };
        this.apiService.sniff(data).subscribe();
    };
    return SessionService;
}());
export { SessionService };



// WEBPACK FOOTER //
// /opt/app/src/app/services/session.service.ts.pre-build-optimizer.js